/* import __COLOCATED_TEMPLATE__ from './people-list.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import LightboxOverlay from 'sh-www/components/modals/overlays/lightbox';
import { showModal } from 'sh-www/utils/modal-controls';
import { SEARCH_REQUEST_PAGE_ERROR } from "sh-www/constants/routes/people-center";

const isNullOrUndefined = (...items) => items.some((item) => item == null);

class PeopleList extends Component {
  searchedLocation = null;
  searchedServices = [];

  willDestroy() {
    super.willDestroy();
    this.args.onProfileOverlayClose();
  }

  get pageControlsDisplayString() {
    const { pageCurrentlyBrowsing, pagination } = this.args;

    if (isNullOrUndefined(pagination.perPage, pagination.total, pageCurrentlyBrowsing)) {
      return null;
    }

    if (pagination.total === 0) {
      return '0 results';
    }

    const displayPageMin = ((pageCurrentlyBrowsing - 1) * pagination.perPage) + 1;
    const displayPageMax = Math.min(pageCurrentlyBrowsing * pagination.perPage, pagination.total);

    return `${displayPageMin} - ${displayPageMax} of ${pagination.total}`;
  }

  get shouldNotAllowForwardNavigation() {
    const { pageCurrentlyBrowsing, searchRequestResults, pagination } = this.args;

    if (isNullOrUndefined(pageCurrentlyBrowsing, searchRequestResults, pagination.totalPages)) {
      return true;
    }

    const nextIndex = pageCurrentlyBrowsing + 1;
    const nextResults = searchRequestResults[nextIndex];

    const shouldAllow = nextResults === SEARCH_REQUEST_PAGE_ERROR || nextResults?.length !== undefined;

    return !shouldAllow;
  }

  get shouldNotAllowBackwardNavigation() {
    const { pageCurrentlyBrowsing, searchRequestResults } = this.args;

    if (isNullOrUndefined(pageCurrentlyBrowsing, searchRequestResults)) {
      return true;
    }

    const nextIndex = pageCurrentlyBrowsing - 1;
    const nextResults = searchRequestResults[nextIndex];

    const shouldAllow = nextResults === SEARCH_REQUEST_PAGE_ERROR || nextResults?.length !== undefined;

    return !shouldAllow;
  }

  @action
  handleProfileMediaClicked(projectdigest, e) {
    e.preventDefault();
    e.stopPropagation();

    showModal(this, LightboxOverlay, {
      digestsToShowForVideoCarousel: [projectdigest],
    });
  }

  @action
  handleProfileLinkClick(profileOverlay, user) {
    this.args.onSetProfileOverlayUser(user);
    this.args.onSetProfileOverlay(profileOverlay);
  }

  @action
  changePage(increment) {
    const { pageCurrentlyBrowsing, pagination } = this.args;
    const validPageChange = (increment < 0 && pageCurrentlyBrowsing > 1) || (increment > 0 && pageCurrentlyBrowsing < pagination.totalPages);

    if ( pageCurrentlyBrowsing != null && pagination.totalPages && validPageChange ) {
      this.args.caProcessPageChange(pageCurrentlyBrowsing + increment);
    }
  }

  constructor() {
    super(...arguments);

    this.searchedLocation = this.args.searchedLocation;
    this.searchedServices = [ ...this.args.searchedServices ];
  }
}

export default PeopleList;
